import React from "react";
import { Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import { safeGetLatLngFromPoint, safeArray } from "./utils/coordinateUtils";

// Röd ikon för penetration, grön för inom-yta-ej-penetration
const redIcon = L.icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  shadowUrl: "/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  shadowSize: [41, 41]
});
const greenIcon = L.icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
  shadowUrl: "/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  shadowSize: [41, 41]
});

function round2(val) {
  return typeof val === "number" ? val.toFixed(2) : "-";
}

export default function PenetrationMarkers({ analysis }) {
  if (!analysis) return null;

  // Samla alla punkter, och för varje punkt en lista av dess matchningar (ytor)
  // Key blir x+y+z med rimlig precision
  const pointsMap = new Map();

  safeArray(analysis).forEach(geoResult => {
    safeArray(geoResult.matches).forEach(match => {
      if (Array.isArray(match.penetrations)) {
        match.penetrations.forEach(pen => {
          // Validate coordinates before processing
          const position = safeGetLatLngFromPoint(pen, `penetration-${pen.x}-${pen.y}`);
          if (!position) {
            console.warn('[PenetrationMarkers] Skipping penetration point with invalid coordinates:', pen);
            return;
          }
          
          // Gör en unik nyckel för punktens position (avrunda för att undvika float-problem)
          const key = `${pen.x.toFixed(6)},${pen.y.toFixed(6)},${pen.z.toFixed(2)}`;
          if (!pointsMap.has(key)) {
            pointsMap.set(key, {
              point: pen,
              matches: []
            });
          }
          pointsMap.get(key).matches.push({
            highlight: !!match.highlight,
            airport_name: match.airport_name,
            surface_name: match.surface_name,
            surface_z: pen.surface_z,
            penetration_delta: pen.penetration_delta,
            type: match.highlight ? "Penetration" : "Inom yta (ej penetration)"
          });
        });
      }
    });
  });

  // Separera i penetration resp. inom-yta-ej-penetration för färg
  const penetrationMarkers = [];
  const insideMarkers = [];

  pointsMap.forEach((val, key) => {
    // Validate coordinates before creating marker
    const position = safeGetLatLngFromPoint(val.point, `penetration-marker-${key}`);
    if (!position) {
      console.warn('[PenetrationMarkers] Skipping marker with invalid coordinates:', val.point);
      return;
    }
    
    // Om någon yta har penetration visas markören som RÖD, annars GRÖN
    const isPenetration = val.matches.some(m => m.highlight);
    const markerIcon = isPenetration ? redIcon : greenIcon;
    const markerList = isPenetration ? penetrationMarkers : insideMarkers;

    markerList.push(
      <Marker
        key={key}
        position={position}
        icon={markerIcon}
      >
        <Tooltip direction="top" offset={[0, -28]}>
          <div>
            {val.matches.map((m, idx) => (
              <div key={idx} style={{marginBottom:6, borderBottom: idx < val.matches.length-1 ? "1px solid #ddd" : "none"}}>
                <b>{m.type}</b><br />
                Airport: {m.airport_name || "-"}<br />
                Yta: {m.surface_name || "-"}<br />
                Surface altitude: {round2(m.surface_z)}<br />
                Diff: {round2(m.penetration_delta)}
              </div>
            ))}
          </div>
        </Tooltip>
      </Marker>
    );
  });

  return (
    <>
      {penetrationMarkers}
      {insideMarkers}
    </>
  );
}